function initParallaxImages() {

	var images = [];
	$('.vertical-image-parallax').each(function () {
		var topStart = $(this).data('parallax-top-start');
		var topEnd = $(this).data('parallax-top-end');
		if(topStart || topEnd){
			images.push(TweenMax.fromTo($(this), 1, {top: topStart}, {top: topEnd, ease: Linear.easeNone}));
		}
	});
	tween = new TimelineMax()
		.add(images);
	new ScrollMagic.Scene({triggerElement: '.parallax-images-container', duration: $(window).height()})
		.setTween(tween)
		.addTo(scrollController);
}
